<div class="user-profile-container">
  <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="user-profile-form">
    <div class="dialog-header">
      <h2 mat-dialog-title>User Profile</h2>
      <button type="button" mat-icon-button [mat-dialog-close]="true" aria-label="Close user profile dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div mat-dialog-content class="user-profile-content">
      <div class="dealer-info-section">
        <div class="dealer-info">
          <div class="info-row">
            <span class="value">{{ dealerInfo.name }}</span>
          </div>
          <div class="info-row">
            <span class="value">{{ dealerInfo.address }}</span>
          </div>
          <div class="info-row">
            <span class="value">{{ dealerInfo.phone }}</span>
          </div>
        </div>
      </div>

      <div>
        <app-highlighted-message></app-highlighted-message>
      </div>

      <div class="user-form-section">
      <div class="form-row">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>First Name <span class="required">*</span></mat-label>
            <input 
              matInput
              type="text" 
              id="firstName" 
              formControlName="firstName">
            <mat-error *ngIf="profileForm.get('firstName')?.invalid">
              First name is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>Last Name <span class="required">*</span></mat-label>
            <input 
              matInput
              type="text" 
              id="lastName" 
              formControlName="lastName">
            <mat-error *ngIf="profileForm.get('lastName')?.invalid">
              Last name is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>Email <span class="required">*</span></mat-label>
            <input 
              matInput
              type="email" 
              id="email" 
              formControlName="email">
            <mat-error *ngIf="profileForm.get('email')?.errors?.['required']">
              Email is required
            </mat-error>
            <mat-error *ngIf="profileForm.get('email')?.errors?.['email']">
              Please enter a valid email
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>Direct Phone</mat-label>
            <input 
              matInput
              id="directPhone" 
              formControlName="directPhone"
              mask="000-000-0000"
              [validation]="false"
              [dropSpecialCharacters]="false"
              placeholder="000-000-0000">
          </mat-form-field>
        </div>
      </div>
      </div>
    </div>

    <mat-dialog-actions align="end" class="user-profile-actions">
      <button type="button" mat-flat-button [mat-dialog-close]="true">Cancel</button>
      <button mat-flat-button color="primary" class="profile-submit" type="submit" [disabled]="disable || loading">
        <mat-spinner *ngIf="loading" class="loading" color="accent" diameter="12"></mat-spinner>
        <span *ngIf="!loading">Save</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
